import React from "react";
import { Link } from "react-router-dom";

export default function AmazingFeatures(){
    const featureData = [
        {
            icon:"mdi mdi-flip-horizontal",
            title:'Plagiarism checker',
            desc:'The phrasal sequence of the is now so that many campaign and benefit'
        },
        {
            icon:"mdi mdi-email-edit-outline",
            title:'Content Generator',
            desc:'The phrasal sequence of the is now so that many campaign and benefit'
        },
        {
            icon:"mdi mdi-star-outline",
            title:'Search Engine Optimization',
            desc:'The phrasal sequence of the is now so that many campaign and benefit'
        },
        
    ]
    return(
        <>
        <div className="container relative md:mt-24 mt-16">
                <div className="grid grid-cols-1 pb-6 text-center">
                    <h3 className="mb-5 mt-5 md:text-3xl md:leading-normal text-2xl leading-normal font-semibold">Empowering Trustable AI Solutions.</h3>

                   
                </div>

      
            </div>
        </>
    )
}